module.exports = __webpack_public_path__ + "img/gf.38dfa23a.svg";